<script lang="ts" setup>
import { Bell } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import NotificationPanel from "./NotificationPanel.vue";
import { useReminderStore } from "~/stores/ReminderStore";

const reminderStore = useReminderStore();
const popoverVisible = ref(false);

onMounted(() => {
  if (!reminderStore.loaded) {
    reminderStore.load();
  }
});
</script>

<template>
  <el-popover
    v-model:visible="popoverVisible"
    placement="bottom-end"
    trigger="click"
    :width="380"
    :show-arrow="false"
    popper-class="notification-bell-popover"
  >
    <template #reference>
      <!--
        Support ticket reminders badge the Support Tickets icon instead, so the bell counts
        everything else — otherwise one reminder would show on both.
      -->
      <el-badge
        :value="reminderStore.generalUnreadCount"
        :hidden="reminderStore.generalUnreadCount === 0"
        :max="99"
        class="notification-bell"
      >
        <el-icon :size="20" class="notification-bell-icon">
          <Bell />
        </el-icon>
      </el-badge>
    </template>
    <NotificationPanel variant="general" @close="popoverVisible = false" />
  </el-popover>
</template>

<style lang="less" scoped>
.notification-bell {
  cursor: pointer;
  display: flex;
  align-items: center;

  &-icon {
    color: var(--el-text-color-regular);
    transition: color 0.15s;

    &:hover {
      color: var(--el-color-primary);
    }
  }
}
</style>
